import styled from '@emotion/styled';

export const Container = styled.div<{ full?: boolean }>`
    width: 100%;
    height: ${({ full }) => full ? '100vh' : '100%'};
    display: flex;
    justify-content: center;
    align-items: center;
`;
